import { useCallback } from 'react';
import { getFetcher } from '@/api/fetchers';

/**
 * Hook that fetches export status based on the exportId in the URL.
 */

interface ExportStatus {
    exportId: string;
    startedAt: string;
    state: string;
    url: string | null;  // URL can be null if the export hasn't finished yet
}

export const useExportStatus = () => {
    const checkExportStatus = useCallback(async (exportId: string): Promise<ExportStatus | null> => {
        try {
            let finished = false;
            let status: ExportStatus | null = null;

            while (!finished) {
                status = await getFetcher(`/exports/${exportId}`) as ExportStatus;
                if (status && status.state === 'FINISHED') {
                    finished = true;
                } else {
                    await new Promise((resolve) => setTimeout(resolve, 2000));
                }
            }
            return status;
        } catch (error) {
            console.error('Error checking export status:', error);
            throw error;
        }
    }, []);
    return {
        checkExportStatus,
    };
};